import { render, staticRenderFns } from "./ItemComponent.vue?vue&type=template&id=30ba0125&scoped=true&"
import script from "./ItemComponent.vue?vue&type=script&lang=js&"
export * from "./ItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba0125",
  null
  
)

export default component.exports